export class AnnouncementTypeFilterConstants {
  static readonly AnyAnnouncementTypeId = 0;
}
